import { buildCreateApi, coreModule, fetchBaseQuery, reactHooksModule } from '@reduxjs/toolkit/query/react';
import { AppCheckTokenResult, getToken } from 'firebase/app-check';
import fetch from 'isomorphic-fetch';

import { getAppCheck } from 'src/firebase-client';
import { CONFIG } from 'constants/index';
import { RootState } from '..';
import { ExtraArgument } from 'client/configure-store';

const customCreateApi = buildCreateApi(coreModule(), reactHooksModule({ unstable__sideEffectsInRender: true }));

const api = customCreateApi({
  reducerPath: 'api',
  tagTypes: [
    'COMPANY',
    'COMPANY_RELATED',
    'MAIN_PAGE_SLIDERS',
    'FAQ',
    'CATEGORIES',
    'CATEGORY',
    'FAVORITE_LIST',
    'COMPANY_WITH_CATEGORY',
    'COMPANY_CLAIMS',
    'STATIC_PAGES',
    'MANDATE',
    'NEWS',
    'OFFER',
    'REPORTS',
    'PORTFOLIO',
    'FAKE_MANDATES_SLIDES',
    'CONTACT_US',
    'FAKE_COMING_SOON_SLIDES',
  ],
  baseQuery: fetchBaseQuery({
    baseUrl: CONFIG.domainUrl,
    ...(typeof window !== 'undefined' && {
      fetchFn: fetch,
    }),
    prepareHeaders: async (headers, { getState, extra }) => {
      let appCheckTokenResponse: AppCheckTokenResult | null = null;

      try {
        const appCheck = getAppCheck();

        if (appCheck) appCheckTokenResponse = await getToken(appCheck, /* forceRefresh= */ false);
      } catch (err) {
        console.info('AppCheck getToken error', err);
      }

      // Include the App Check token with requests to your server.
      headers.set('X-Firebase-AppCheck', appCheckTokenResponse?.token ?? 'app-check-naebahtung');

      if (typeof window === 'undefined') {
        headers.set('X-Firebase-AppCheck', process.env.SSR_APP_CHECK_TOKEN ?? '');
      }

      const state = getState() as RootState;
      const sessionCookie = (extra as ExtraArgument)?.sessionCookie ?? '';

      const lang = state.settings.lang ?? 'en';
      const user = state.user;

      headers.set('Accept-Language', lang);

      if (user.auth.isLoggedIn) {
        headers.set('X-User-Role', user.role);
      }

      if (sessionCookie) {
        headers.set('x-session', sessionCookie);
      }
    },
  }),
  extractRehydrationInfo(action) {
    if (action.type === 'HYDRATE') {
      return action.payload;
    }
  },
  endpoints: () => ({}),
});

export default api;
